<template>
    <div :style="useMinHeight&&graphic&&graphic.type==='3D' ? 'min-height:'+graphic.config.height+'px;' : ''">
        <forge-viewer-widget v-if="graphic&&graphic.type==='3D'&&graphic.config.link&&graphic.config.link!==''" :url="graphic.config.link"
                             :height="height ? height : graphic.config.height" :selected-items="selectorControl"
                             :lighting-preset="lightingPreset" :ground-shadow="groundShadow" :ground-reflection="groundReflection"
                                :node-names-to-hide="nodeNamesToHide" :node-names-to-remove="nodeNamesToRemove" :mode-name-to-focus="modeNameToFocus"
                             :highlighted-items="highlightControl" @select="handle3DSelect" :forced-background="forcedBackground" :lock-nav="lockNav"></forge-viewer-widget>
        <bms-widget v-if="graphic&&graphic.type==='SVG'" :latest-only="graphic.config.latestOnly" :svg="graphic.config.svg"></bms-widget>
    </div>
</template>

<script>

import {getGraphic, getNotification} from '../helper'
import ForgeViewerWidget from "./widgets/ForgeViewerWidget";
import BmsWidget from "./widgets/BmsWidget";

export default {
    props: {
        graphicId: {type: Number, default: null},
        height: {type: Number, default: null},
        lightingPreset: {type: Number, default: null},
        selectedEquipments: {type: Array, default: null},
        menuMode: {type: Boolean, default: false},
        menuPath: {type: String, default: null},
        inPageMenu: {type: Boolean, default: false},
        healthMode: {type: Boolean, default: false},
        dateRange: {type: Object, default: null},
        useMinHeight:{type:Boolean, default: false},
        groundShadow:{type:Boolean, default: false},
        lockNav:{type:Boolean, default: false},
        groundReflection:{type:Boolean, default: false},
        nodeNamesToHide: {type: String, default: null},
        nodeNamesToRemove: {type: String, default: null},
        modeNameToFocus: {type: String, default: null},
        forcedBackground: {type: String, default: null},
    },
    components: {ForgeViewerWidget,BmsWidget},
    data() {
        return {
            selectorControl:[],
            highlightControl:[],
            graphic:null,
        }
    },
    name: 'EquipmentGraphicRenderer',
    async mounted(){
        if(this.graphicId){
            let df = await getGraphic({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                graphic_id:this.graphicId
            })
            let graphic = df['result']
            if(graphic){
                if(graphic.config&&graphic.config.mappings){
                    if (this.menuMode){
                        this.highlightControl=graphic.config.mappings.map(x=>{return {'id':x.id}})
                    } else if (this.healthMode){
                        let notifsResult = await getNotification({
                            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            date_range:this.dateRange ? [this.dateRange.start,this.dateRange.end] : null,
                        })
                        let filteredNotifs=notifsResult.result.filter(function(x) {return !x.acknowledged&&x.topic==="equipment health" })
                        this.highlightControl=graphic.config.mappings.map(x=>{
                            let item={'id':x.id}
                            let severities=filteredNotifs.filter(notif=>notif.equipment_name===x.equipmentName).map(notif=>notif.severity)
                            if (severities.includes("critical")){
                                item.color=[100,32,32]
                            } else if (severities.includes("high")){
                                item.color=[98,55,0]
                            } else if (severities.includes("medium")){
                                item.color=[100,76,3]
                            }else {
                                item.color=[61, 220, 132]
                            }
                            return item
                        })
                    }
                    if(this.selectedEquipments){
                        this.selectorControl=graphic.config.mappings.filter(x=>this.selectedEquipments.includes(x.equipmentName)).map(x=>x.id)
                    }
                }
                this.graphic=graphic
            }
        }
    },
    methods:{
        handle3DSelect(data){
            if (this.graphic&&this.graphic.config&&this.graphic.config.mappings&&data&&data.dbIdArray&&data.dbIdArray.length===1){
                let mathcingItem=this.graphic.config.mappings.filter(x=>data.dbIdArray.includes(x.id))[0]
                if (mathcingItem && mathcingItem.equipmentName) {
                    if (this.menuMode) {
                        if (this.inPageMenu) {
                            this.$emit('forceselectequipment', mathcingItem.equipmentName)
                        } else if (this.menuPath&&this.menuPath!=='') {
                            this.$router.push({path: this.menuPath, query: {equipment: mathcingItem.equipmentName}})
                        } else {
                            this.$router.push({path: '/equipment-summary', query: {equipment: mathcingItem.equipmentName}})
                        }
                    } else if (this.healthMode) {
                        this.$router.push({path: '/equipment-health', query: {equipment: mathcingItem.equipmentName}})
                    }
                } else if (this.menuMode&&this.inPageMenu){
                    this.$emit('forceselectequipment', null)
                }
            }
        },
    }
}
</script>

<style scoped>

</style>
